import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import projects from "../Data/projects";

function ProjectDetail() {
    const { id } = useParams();
    const project = projects.find((p) => p.id === id);

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);

    if (!project) return <p className="text-center mt-12">Project not found.</p>;
    if (!project.gallery || project.gallery.length === 0) return <p className="text-center mt-12">No images available for this project.</p>;

    return (
        <section className="max-w-[1000px] mx-auto p-2 space-y-4">
            <h1 className="text-center text-3xl sm:text-5xl font-bold">{project.title}</h1>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 justify-center">
                {project.tags.map((tag, idx) => (
                    <span key={idx} className="bg-gray-200 px-3 py-1.5 rounded-xl text-sm font-medium">
                        {tag}
                    </span>
                ))}
            </div>

            {/* Project Description */}
            <p className="text-center max-w-[700px] mx-auto mb-4 px-2 sm:px-0">
                {project.descriptionFull}
            </p>

            {/* Completed Date */}
            <p className="text-center text-gray-600 border-b-2">Completed: {project.date}</p>

            {/* Selected Image Description above the image */}
            <div className="flex flex-col gap-2 md:flex-row md:gap-8 justify-center items-center pt-8">
                <div className="flex-1 min-w-[250px] text-center md:text-left">
                    <p className="mb-2">{project.gallery[selectedIndex].description}</p>
                </div>
                <img
                    src={project.gallery[selectedIndex].src}
                    alt={`${project.title} ${selectedIndex + 1}`}
                    className="w-full md:w-[80%] max-h-[45vh] rounded-lg object-contain lg:object-contain cursor-pointer"
                    onClick={() => setIsFullscreen(true)}
                />
            </div>

            {/* Thumbnails */}
            <div className="flex flex-wrap gap-2 mt-6 justify-center">
                {project.gallery.map((img, idx) => (
                    <img
                        key={idx}
                        src={img.src}
                        alt={`${project.title} thumbnail ${idx + 1}`}
                        className={`rounded-lg cursor-pointer object-cover transition-all duration-200 
                            ${selectedIndex === idx ? "w-20 h-20 sm:w-24 sm:h-24 border-2 border-black" : "w-16 h-16 sm:w-20 sm:h-20 border border-gray-300"}`}
                        onClick={() => setSelectedIndex(idx)}
                    />
                ))}
            </div>

            {/* Back Link */}
            <div className="mt-8 md:mt-12 text-center">
                <Link to="/projects" className="text-gray-800 font-medium no-underline">
                    ← Back to Projects
                </Link>
            </div>

            {/* Fullscreen Overlay */}
            {isFullscreen && (
                <div className="fixed top-0 left-0 w-screen h-screen bg-black/90 flex justify-center items-center z-[2000] p-4 sm:p-8">
                    <button
                        onClick={() => setIsFullscreen(false)}
                        className="absolute top-4 right-4 sm:top-5 sm:right-8 text-white text-2xl sm:text-3xl font-bold cursor-pointer"
                    >
                        ✕
                    </button>
                    <img
                        src={project.gallery[selectedIndex].src}
                        alt="Fullscreen"
                        className="max-w-full sm:max-w-[90%] max-h-[80vh] sm:max-h-[90%] rounded-lg object-contain"
                    />
                </div>
            )}
        </section>
    );
}

export default ProjectDetail;
